import { render } from "./TableWithChart.vue?vue&type=template&id=eda7f000&scoped=true"
import script from "./TableWithChart.vue?vue&type=script&lang=js"
export * from "./TableWithChart.vue?vue&type=script&lang=js"

import "./TableWithChart.vue?vue&type=style&index=0&id=eda7f000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda7f000"]])

export default __exports__